var React = require('react');

function ArrowsUpDownDark (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"points":"-10,4.141,-7.032,-1,-4.064,4.141","fill":"rgb(0,0,0)","key":0}),React.createElement("polygon",{"points":"-9.936,6.253,-6.968,11.393,-4,6.253","fill":"rgb(0,0,0)","key":1})]));
}

ArrowsUpDownDark.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"-10 -1 6 12.393","width":"6pt","height":"12.393pt"};

module.exports = ArrowsUpDownDark;

ArrowsUpDownDark.default = ArrowsUpDownDark;
